import type { Entry, Frise as FriseData } from "./api";

/**
 * Le bac « à dater », sous la frise : les points sans date, chacun avec « Dater ». Sans `onDate`
 * (la vue d'un proche), la liste seule.
 */
export function UndatedTray({
  entries,
  tracks,
  onDate,
}: {
  entries: readonly Entry[];
  tracks: FriseData["tracks"];
  onDate?: (entry: Entry) => void;
}) {
  if (entries.length === 0) return null;
  return (
    <section aria-labelledby="a-dater" className="flex flex-col gap-3">
      <h2 className="m-0 text-[15px] font-semibold" id="a-dater">
        À dater ({entries.length})
      </h2>
      <ul className="m-0 flex list-none flex-col gap-2 p-0">
        {entries.map((entry) => {
          const track = tracks.find((item) => item.id === entry.trackId);
          return (
            <li
              className="flex items-center justify-between gap-3 rounded-xl border border-border bg-card py-1.5 pr-1.5 pl-3.5"
              key={entry.id}
            >
              <span className="flex min-w-0 items-center gap-2.5">
                <span
                  aria-hidden="true"
                  className="size-2.5 shrink-0 rounded-full"
                  style={{ background: track?.color ?? "#AEB6C8" }}
                />
                <span className="flex min-w-0 flex-col">
                  <span className="truncate text-sm">{entry.title}</span>
                  <span className="text-xs text-muted-foreground">
                    {track?.name ?? "Sans piste"}
                  </span>
                </span>
              </span>
              {onDate === undefined ? null : (
                <button
                  aria-label={`Dater « ${entry.title} »`}
                  className="min-h-11 shrink-0 rounded-[10px] border border-input px-3.5 text-sm"
                  onClick={() => onDate(entry)}
                  type="button"
                >
                  Dater
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
